module.exports = __webpack_public_path__ + "static/img/cj_submit_ok_bj.e4c6b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cj_submit_ok_bj.png
// module id = mQjC
// module chunks = 0